import { AppData, Lightning, Utils } from '@lightningjs/sdk'
import { AppSetup } from '../lib/app-setup'
import { Helper } from '../lib/helper'
import { Shadow } from '@lightningjs/ui-components'

export interface StarUITemplateSpec extends Lightning.Component.TemplateSpec {
  Icons: object
}

export default class StarUI extends Lightning.Component<StarUITemplateSpec> implements Lightning.Component<StarUITemplateSpec> {

  static override _template(): Lightning.Component.Template<StarUITemplateSpec> {
    return {
    }
  }

  set rating(value) {
    const stars = this._createStars(value)
    this.patch({
      Icons: {
        w: this.finalW,
        h: this.finalH,
        flex: { direction: 'row' },
        children: stars
      }
    })
  }

  percentageToStarArray(percentage:number, totalStars = 5) {
    // Calculate the star rating
    let starRating = (percentage / 100) * totalStars;

    // Determine the number of filled stars
    let filledStars = Math.floor(starRating);

    // Check if there is a half star
    let frac = (starRating - filledStars)

    // Create the array for filled stars
    let starsArray = Array(filledStars).fill(4);

    // Add half star if needed
    if (frac > 0) {
      starsArray.push(Math.round((frac * 100) / 25));
    }

    // Fill the rest with empty stars
    while (starsArray.length < totalStars) {
      starsArray.push(0);
    }

    return starsArray;
  }

  _createStars(perc:number) {
    const tmap = this.percentageToStarArray(perc, 5)
    const { appState} = AppData as AppSetup
    const appApiConfig = appState?.getAppApiConfig()
    const color = Helper.getHexaColor(appApiConfig?.appLayoutConfig.textfocuscolor)
    return Array.from({ length: 5 }).map((_, i) =>
    ({
      w: this.finalH,
      h: this.finalH,
      texture: {
        w: 72,
        h: 72,
        x: tmap[i] * 72,
        type: Lightning.textures.ImageTexture,
        src: Utils.asset('images/stars-inline-72.png')
      },
      colorUl: color, colorUr: color, colorBl: color, colorBr: color
    }))
  }

}
